import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'product-type/',
    pluginName: 'LOGISTIC',
    entityName: 'PRODUCT_TYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false
});

// Fetch ProductType action creators
export const fetchProductTypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchProductTypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchProductTypeSuccess = (fetchProductTypeCount, listProductTypeCount) => {
    return crudActions.fetchSuccess(fetchProductTypeCount, listProductTypeCount);
};
export const fetchProductTypeFail = () => {
    return crudActions.fetchFail();
};

export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name} (${productType.Key})`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes;
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchProductTypeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchProductTypeStart());
        try {
            let countRes = await rest.post("product-type/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchProductTypeSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchProductTypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch product types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchProductTypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch product types."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
};

export const fetchProductType = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchProductTypeStart());
        try {
            let listRes = await rest.post("product-type/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchProductTypeSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            else {
                dispatch(fetchProductTypeFail());
                return []
            }
        } catch (error) {
            dispatch(fetchProductTypeFail());
            return []

        }
    }
};


// load product type
export const loadProductTypeInit = () => { return crudActions.loadInit(); };
export const loadProductType = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};


// Edit product type action creators
export const editProductTypeInit = () => {
    return crudActions.editInit();
};
export const editProductTypeStart = () => {
    return crudActions.editStart();
};
export const editProductTypeSuccess = productType => {
    return crudActions.editSuccess(productType);
};
export const editProductTypeFail = error => {
    return crudActions.editFail(error);
};


export const editProductType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editProductTypeStart());
        try {
            let res = await rest.post('/product-type/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editProductTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated product type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editProductTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit product type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit product type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editProductTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete product type 
export const bulkDeleteProductTypeInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteProductTypeStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteProductTypeSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteProductTypeFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteProductType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteProductTypeStart());
        try {
            let res = await rest.post('/product-type/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteProductTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted product types.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteProductTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete product types."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete product types."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteProductTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Create productType  action creators
export const createProductTypeInit = () => {
    return crudActions.createInit();
};
export const createProductTypeStart = () => {
    return crudActions.createStart();
};
export const createProductTypeSuccess = productType => {
    return crudActions.createSuccess(productType);
};
export const createProductTypeFail = error => {
    return crudActions.createFail(error);
};

export const createProductType = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createProductTypeStart());
        try {
            let res = await rest.post('/product-type/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createProductTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created product type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createProductTypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create product type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create product type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createProductTypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}